import React from 'react'


export function UiBottomNavBar(props) {

    return (
        <>
            <div className='sb-mobile-bottom-nav-bar'>
                {props.children}
            </div>

        </>
    )
}

export function UiBottomNavBarItem(props) {

    return (
        <>

            <div className='sb-mobile-bottom-nav-bar__section'>
                <div className='sb-mobile-bottom-nav-bar__icon'>
                    <img src={props.navIcon} />
                </div>
                <div className='sb-mobile-bottom-nav-bar__title'>
                    <h5>{props.navTitle}</h5>
                </div>
            </div>


        </>
    )
}